module.exports = __webpack_public_path__ + "img/75.7bb0880b.png";